import cn from "@/util/cn";
import { ComponentPropsWithoutRef } from "react";
import Breadcrumbs from "./Breadcrumbs";
import Navigation from "./Navigation";

type PageProps = {
  breadcrumbs?: { title: string; url?: string }[];
} & ComponentPropsWithoutRef<"div">;

const Page = ({ breadcrumbs = [], className, children }: PageProps) => {
  return (
    <div className={cn("flex h-full flex-col", className)}>
      <Navigation className="shrink-0 px-8 py-4" />
      <Breadcrumbs breadcrumbs={breadcrumbs} className="mb-5 mt-4 shrink-0 px-8" />
      <div className="grow px-8">{children}</div>
    </div>
  );
};

export default Page;
